"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Icon from "./icon.js";
export const MinusDuplicateIcon = React.forwardRef(function MinusDuplicateIcon(props, ref) {
    return (_jsxs(Icon, Object.assign({ ref: ref }, props, { children: [_jsx("rect", { height: "14", rx: "2", width: "14", x: "8", y: "8" }), _jsx("path", { d: "M5.23 16H4.155c-.571 0-1.12-.227-1.524-.631S2 14.417 2 13.846V4.154C2 2.964 2.964 2 4.154 2h9.692C15.036 2 16 2.964 16 4.154V5.23M12 15h6" })] })));
});
export default MinusDuplicateIcon;
//# sourceMappingURL=minus-duplicate.js.map